import { render, staticRenderFns } from "./DeviceForm.vue?vue&type=template&id=5d6f2124"
import script from "./DeviceForm.vue?vue&type=script&lang=js"
export * from "./DeviceForm.vue?vue&type=script&lang=js"
import style0 from "./DeviceForm.vue?vue&type=style&index=0&id=5d6f2124&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports